import { Toast, Dialog } from 'vant'
let windowMethdId = 0 //记录全局方法id
// 获取cookie 同步vue和main项目
const _getCookie = function (name) {
  let token = null
  let arr = []
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) token = unescape(arr[2])
  return token
}
/* cookie中的值不确定是数字还是字符串，所以先转number */
let isHarmony = +_getCookie('appBetterWEJSBridge') //是否在鸿蒙手机app 0 不是 1 是
const app = {
  /* 通用方法 */
  commonMethod(methodName, params) {
    return new Promise((resolve, reject) => {
      if (!this.isApp()) {
        reject('请在app内打开')
        return
      }
      if (params === undefined) {
        params = {}
      }
      let windowMethodName = 'betterweAppCallBack' + windowMethdId++
      if (isHarmony) {
        try {
          window.betterWEJSBridge.postMessage(
            JSON.stringify({
              action: methodName,
              params: params,
              callbackMethod: windowMethodName
            })
          )
        } catch (error) {
          console.log('鸿蒙调用方法失败', error)
          reject('鸿蒙调用方法失败')
        }
      } else {
        //android和ios
        if (!window[methodName]) {
          console.log(`${methodName}方法不可用`)
          reject(`${methodName}方法不可用`)
          return
        }
        if (typeof params == 'object') {
          params.callbackMethod = windowMethodName
        }
        let finalParams =
          typeof params === 'object' ? JSON.stringify(params || {}) : params
        window[methodName].postMessage(finalParams)
      }
      console.log('调用api：' + methodName)
      window[windowMethodName] = (res) => {
        console.log(methodName + '调用返回', res)
        resolve(res)
        window[windowMethodName] = null
      }
    })
  },
  // 是否是鸿蒙
  isHarmony() {
    return isHarmony
  },
  // 获取健萌token
  addJMToken() {
    return this.commonMethod('addJMToken').catch(() => {})
  },
  // 解决IOS 18.2以上的版本拉起全局权限弹窗后 点击事件失效问题 临时方案
  // permissionText 权限文案  唯一标识
  // pass  是否每次绕过重复判断 每次都拉起权限弹窗  默认false 不绕过 当拉起权限场景是用户点击行为是应为true 每次都拉起权限弹窗
  isPermissionDialogHappened(permissionText, pass = false) {
    if (!this.isApp()) return false
    let agent = (
      navigator.userAgent ||
      navigator.vendor ||
      window.opera
    ).toLowerCase()
    const isIOS =
      /ipad|iphone|ipod/.test(agent) || /macintosh|mac os x/i.test(agent)
    if (!isIOS) {
      console.log('安卓不需要处理')
      return true
    }
    permissionText = 'permissionDialogClickCallback_' + permissionText
    if (!pass && sessionStorage.getItem(permissionText)) {
      sessionStorage.removeItem(permissionText)
      console.log('当前是解决IOS点击事件失效刷新页面，不需要再调用权限api')
      return false
    }
    //  弹窗交互回调res 0 没有权限 1 有权限
    window.permissionDialogClickCallback = function (res) {
      console.log('触发弹窗交互回调', res)
      // 用户拒绝 没有权限则保存sessionStorag  刷新页面后本次流程不再调用权限弹窗
      if (res == 0) {
        sessionStorage.setItem(permissionText, 'true')
      }
      location.reload()
    }
    return true
  },

  //配置webview导航栏
  initWebViewUIConfig(params) {
    return this.commonMethod('initWebViewUIConfig', params).catch(() => {})
  },
  //是否在app内
  isApp() {
    // 老版 全局onAppPageRoute方法   新版 betterWEJSBridge（目前鸿蒙 后续会加安卓ios）
    return window.onAppPageRoute || window.betterWEJSBridge ? true : false
  },
  //url 方式跳转app内界面
  onAppPageUrlRoute(url) {
    return this.commonMethod('onAppPageUrlRoute', url).catch(() => {})
  },
  /*
    {
      跳转页面路径  
      "path":"/search",
      跳转所需参数
           params:[
            {"key":"id","value":"idvalue"},  
            {"key":"keywords","value":"搜索内容"},  
          ]}
    */
  //json 方式跳转app内界面
  onAppPageRoute(params) {
    return this.commonMethod('onAppPageRoute', params).catch(() => {})
  },
  //分享app
  onAppShare(params) {
    return this.commonMethod('onAppShare', params).catch((err) => {
      console.log('分享失败', err)
    })
  },
  //检查app是否需要更新，传入版本号则判断是否小于这个版本，小于则更新。 不传参则默认检查更新
  checkAppUpdate: async function (version = Infinity) {
    let res = await this.getAppDevicesInfo().catch(() => {})
    if (res && res.clientversion < version) {
      this.commonMethod('checkAppUpdate', '')
    }
  },
  //获取app设备信息
  getAppDevicesInfo() {
    return this.commonMethod('getAppDevicesInfo')
  },
  //用于跳转微信支付宝等第三方
  jumpUrlSchema: async function (url) {
    let res = await this.getAppDevicesInfo().catch(() => {})
    //新版直接跳转微信客服需要app版本大于等于60
    if (res && res.clientversion >= 60) {
      location.href = url
    } else {
      Toast('当前app版本过低，不能跳转到该链接，请更新app')
    }
  },
  //是否是游客
  isGuest() {
    return new Promise(async (resolve, reject) => {
      let isLogin = await this.commonMethod('isAppLogin').catch(() => {})
      if (isLogin * 1 !== 0) {
        resolve(false)
      } else {
        resolve(true)
      }
    })
  },
  //app是否登陆
  async isLogin(calback) {
    let res = await this.commonMethod('isAppLogin').catch(() => {})
    console.log('是否登录结果', JSON.stringify(res))
    if (res !== undefined) {
      let isLogin = res * 1 !== 0
      if (isLogin) {
        //更新token
        this.updateToken()
          .then(() => {
            calback && calback()
          })
          .catch(() => {
            Toast('更新登录失败')
          })
      } else {
        //去app登录  兼容flutter onFirstLogin不支持自定义回调函数名
        window.loginSuccessCallback = () => {
          this.updateToken()
            .then(() => {
              calback && calback()
            })
            .catch(() => {
              Toast('更新登录失败')
            })
        }
        await this.commonMethod('onFirstLogin')
        this.updateToken()
          .then(() => {
            calback && calback()
          })
          .catch(() => {
            Toast('更新登录失败')
          })
      }
    }
  },
  // 获取app token
  getAppToken() {
    return this.commonMethod('getAppToken').catch(() => {})
  },
  //更新页面的token
  updateToken() {
    return new Promise(async (resolve, reject) => {
      let token = await this.commonMethod('getAppToken').catch(() => {
        reject()
      })
      if (token) {
        sessionStorage.setItem('token', token)
        localStorage.setItem('token', token)
      }
      resolve()
    })
  },
  //获取app版本信息
  getAppVersion() {
    return new Promise(async (resolve, reject) => {
      let res = await this.getAppDevicesInfo().catch(() => {
        reject()
      })
      resolve((res && res.clientversion) || 0)
    })
  },
  //获取当前app环境 如果是正式配置了测试路径则给出弹框提示
  getEnv() {
    this.getAppDevicesInfo()
      .then((res) => {
        if (res) {
          if (
            res.env == 'pro' &&
            location.href.indexOf('tbtvue.gymcity.com') >= 0 &&
            !location.href.includes('/betterwe/vip-agreement')
          ) {
            Dialog.alert({
              title: '提示',
              message: '当前为测试环境'
            })
          }
        }
      })
      .catch(() => {})
  },
  //保存图片到相册  data:图片链接或者base64  type:图片类型 app没有回调
  onAppSaveImage(params) {
    let type = params.type || 'url'
    this.commonMethod('onAppSaveImage', {
      data: params.data, //分享的具体数据
      //分享的数据的格式
      //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
      type: type
    })
  },
  /* 跳转小程序  appId:原始id  path:页面路径加参数，参数需编码 */
  async jumpMiniProgram(params = {}) {
    //默认减脂营小程序
    params.appId = params.appId || 'gh_0d804ee2c21b'
    if (!params.path) {
      Toast('小程序路径不存在')
      return
    }
    // wxMiniProgramType 0正式---对应正式版 1测试---对应开发版 2预览版---对应体验版
    const envInfo = await this.getAppDevicesInfo().catch(() => {})
    this.commonMethod(
      'onAppPageUrlRoute',
      `/miniProgram?userName=${params.appId}&path=${
        params.path
      }&wxMiniProgramType=${envInfo?.env === 'pro' ? 0 : 2}`
    )
  },
  /*
    发送友盟埋点事件
    {   事件id "eventId": "", 事件参数 "params": [{ "key": "id","value": 51791}]}
    */
  sendUMEvent(params) {
    this.commonMethod('sendUMEvent', params)
  },
  //获取定位信息
  requestLocation() {
    return new Promise(async (resolve, reject) => {
      if (!this.isApp()) reject('获取位置失败，不在app内')
      // 判断是否有缓存的经纬度api
      if (window.addRequestLocationCache) {
        let cacheRes = await this.commonMethod('addRequestLocationCache')
        if (
          cacheRes &&
          typeof cacheRes === 'object' &&
          cacheRes.longitude &&
          cacheRes.longitude != '0'
        ) {
          // app有缓存的经纬度
          resolve({
            errorCode: 0,
            longitude: cacheRes.longitude,
            latitude: cacheRes.latitude
          })
        } else {
          // 没有缓存的经纬度 则判断7天内是否请求过定位权限api 没有则请求
          let location7daysLocal = localStorage.getItem('location7daysLocal')
          if (
            location7daysLocal &&
            new Date(location7daysLocal).getTime() >
              Date.now() - 7 * 24 * 60 * 60 * 1000
          ) {
            reject('获取位置失败，7天内请求过定位权限api')
          } else {
            if (this.isPermissionDialogHappened('requestLocation')) {
              localStorage.setItem('location7daysLocal', new Date())
              let res = await this.commonMethod('requestLocation').catch(() => {
                reject('从App获取经纬度失败')
              })
              if (res !== undefined) {
                resolve(typeof res === 'string' ? JSON.parse(res) : res)
              } else {
                reject('从App获取经纬度失败')
              }
            } else {
              reject('从App获取经纬度失败')
            }
          }
        }
      } else {
        if (this.isPermissionDialogHappened('requestLocation')) {
          let res = await this.commonMethod('requestLocation').catch(() => {
            reject('从App获取经纬度失败')
          })
          if (res !== undefined) {
            resolve(typeof res === 'string' ? JSON.parse(res) : res)
          } else {
            reject('从App获取经纬度失败')
          }
        } else {
          reject('从App获取经纬度失败')
        }
      }
    })
  },
  //进入app扫码页面
  onAppScanQRCode() {
    return this.commonMethod('onAppScanQRCode')
  },
  //进入app的选择照片界面
  onAppCamera() {
    try {
      if (this.isPermissionDialogHappened('onAppCamera', true)) {
        return this.commonMethod('onAppCamera').catch(() => {})
      } else {
        return Promise.reject('获取图片失败')
      }
    } catch (error) {
      Toast('操作失败，请开启相机、图库权限')
    }
  },
  //进入app的直接拉起拍照页
  addAppCameraTakePhotos() {
    try {
      if (this.isPermissionDialogHappened('addAppCameraTakePhotos', true)) {
        return this.commonMethod('addAppCameraTakePhotos').catch(() => {})
      } else {
        return Promise.reject('拉起拍照失败')
      }
    } catch (error) {
      Toast('操作失败，请开启相机、图库权限')
    }
  },
  //获取手机是否打开了通知权限
  getNotificationPermissionStatus() {
    return this.commonMethod('getNotificationPermissionStatus').catch(() => {})
  },
  //申请手机通知权限
  requestNotificationPermission() {
    return this.commonMethod('requestNotificationPermission').catch(() => {})
  },
  //保存数据到app本地
  /*
    {  "key":"key" //保存的key  "value":"value"保存的值}
    */
  saveAppLocalData(params) {
    this.commonMethod('saveAppLocalData', params)
  },
  //获取app本地数据
  /*
    {  "key":"key" //保存的key  "callbackMethod":"callbackMethod" 回调方法}
    */
  getAppLocalData(key) {
    return this.commonMethod('getAppLocalData', { key }).catch(() => {})
  },
  //跳转app路由
  jumpRoute(router) {
    return new Promise(async (resolve, reject) => {
      if (!router) {
        Toast('跳转页面信息不能为空')
        resolve(false)
        return
      }
      let method
      if (typeof router == 'string') {
        method = 'onAppPageUrlRoute'
      } else {
        method = 'onAppPageRoute'
      }
      //兼容flutter 路由跳转不支持自定义回调函数名
      window.onAppPageUrlRouteCallback = () => {
        resolve(true)
      }
      await this.commonMethod(method, router).catch(() => {
        resolve(false)
      })
      resolve(true)
    })
  },
  jumpWeb(url) {
    return new Promise(async (resolve, reject) => {
      if (url) {
        let res = await this.jumpRoute(`/web?url=${encodeURIComponent(url)}`)
        resolve(res)
      } else {
        resolve(false)
        Toast('跳转web链接不能为空')
      }
    })
  },
  //跳转微盟商城
  jumpWmStore(url) {
    if (!url) {
      Toast('商城url不能为空')
      return
    }
    this.jumpRoute(
      '/wmOtherPage?fromType=11&url=' + encodeURIComponent(url) + '&title=商城'
    )
  },
  /* 打开第三方app */
  async launchUrlApp(path, callback) {
    if (!path) {
      Toast('路径不能为空')
      return
    }
    let fullPath = '/launchUrlApp?url=' + encodeURIComponent(path)
    //兼容flutter 路由跳转不支持自定义回调函数名
    window.onAppPageUrlRouteCallback = (res) => {
      callback(res)
      window.onAppPageUrlRouteCallback = null
    }
    await this.commonMethod('onAppPageUrlRoute', fullPath).catch(() => {})
    callback(res)
  },
  //退出登录
  async onAccountExit() {
    let res = await this.commonMethod('onAccountExit').catch(() => {})
    if (res) {
      Toast({
        message: res,
        duration: 20000
      })
    }
  },
  /* 更新apptoken */
  updateAppToken(data) {
    this.commonMethod('updateAppToken', {
      token: data.token,
      tokenExpireTime: data.token_expire_time
    }).catch(() => {})
  },
  addUpdateUgcDataEvent(obj) {
    let params = {
      id: 0,
      type: 1, // 1点赞  2评论  3关注  4收藏
      count: 0, //数量
      isLike: 0, //是否是点赞
      isFollow: 0, //是否是关注
      isCollect: 0 //是否是收藏
    }
    params = Object.assign(params, obj)
    this.commonMethod('addUpdateUgcDataEvent', params).catch(() => {})
  },
  /* webview 返回上个历史页面 */
  onWebViewBack() {
    return this.commonMethod('onWebViewBack').catch(() => {})
  },
  /* 关闭app 当前webview */
  onAppCloseRoute() {
    return this.commonMethod('onAppCloseRoute').catch(() => {})
  },
  /* 获取手机状态栏高度 */
  getAppBarHeight() {
    return new Promise(async (resolve, reject) => {
      if (!this.isApp()) {
        resolve({
          toolsBarHeight: 0,
          statusBarHeight: 0
        })
      }
      let res = await this.commonMethod('getAppBarHeight').catch(() => {})
      if (res) {
        resolve(typeof res === 'string' ? JSON.parse(res) : res)
      } else {
        reject(res)
      }
    })
  },
  /* 跳转vip首页 */
  async vipHomePage(params = {}) {
    let version = await this.getAppVersion().catch(() => {})
    let url = version > 200 ? '/vipHomePage' : '/vipBuyPage'
    if (Object.keys(params).length) {
      let queryString = Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join('&')
      url += `?${queryString}`
    }
    this.jumpRoute(url)
  },
  //跳转苹果支付
  async jumpApplePlaceOrder(bwtGoodsId, appleProductId) {
    return new Promise(async (resolve, reject) => {
      let params = {
        goodsInfo: {
          bwtGoodsId,
          appleProductId
        }
      }
      let res = await this.commonMethod('applePlaceOrder', params).catch(
        () => {}
      )
      if (res) {
        res = typeof res == 'string' ? JSON.parse(res) : res
        resolve(res)
      } else {
        reject()
      }
    })
  },
  /* 打开定位设置 */
  openLocationSettings() {
    return this.commonMethod('openLocationSettings')
  },
  /* 完成新人问卷后通知app */
  addCompleteTest() {
    return this.commonMethod('addCompleteTest').catch(() => {})
  },
  /* 加载微盟web页面 */
  loadWMHomeWebPage() {
    return this.commonMethod('loadWMHomeWebPage').catch(() => {})
  },
  // 处理课程预约完成 上报日期，验证日历、通知权限
  addGymCourseAppointmentComplete(
    obj,
    methodType = 'createOrUpdateCalendarEvent'
  ) {
    return new Promise(async (resolve, reject) => {
      // 解决IOS 18.2以上版本拉起全局权限弹窗后 点击事件失效问题 临时方案
      if (
        this.isApp() &&
        this.isPermissionDialogHappened('addGymCourseAppointmentComplete')
      ) {
        // 向原生端发送课程预约完成消息
        let res = await this.commonMethod('addGymCourseAppointmentComplete', {
          methodType,
          params: JSON.stringify(obj)
        }).catch(() => {})
        if (res !== undefined) {
          resolve(res)
        } else {
          resolve()
        }
      } else {
        resolve()
      }
    })
  },
  // 去开启通知权限
  addOpenPermission() {
    this.commonMethod('addOpenPermission').catch(() => {})
  },
  // 获取日历中已设置的日程列表
  getCalendarList() {
    return new Promise(async (resolve, reject) => {
      let res = await this.commonMethod('calendarChannelMethod', {
        methodType: 'getCalendarList',
        params: JSON.stringify({})
      }).catch(() => {})
      if (res !== undefined) {
        try {
          res = typeof res === 'string' ? JSON.parse(res) : res
          if (res.code == 0) {
            resolve(res.data)
          } else {
            reject(res)
          }
        } catch (error) {
          reject(error)
        }
      }
      reject()
    })
  },
  // 获取日历中已设置的日程事件列表
  getCalendarEventList(calendarId) {
    return new Promise(async (resolve, reject) => {
      let res = await this.commonMethod('calendarChannelMethod', {
        methodType: 'getCalendarEventList',
        params: JSON.stringify({ calendarId })
      }).catch(() => {})
      if (res !== undefined) {
        try {
          res = typeof res === 'string' ? JSON.parse(res) : res
          if (res.code == 0) {
            resolve(res.data)
          } else {
            reject(res)
          }
        } catch (error) {
          reject(error)
        }
      }
      reject()
    })
  },
  // 取消日历中的日程
  deleteCalendar(calendarId) {
    if (!calendarId) {
      console.error('calendarId不能为空')
      return
    }
    this.commonMethod('calendarChannelMethod', {
      methodType: 'deleteCalendar',
      params: JSON.stringify({
        calendarId
      })
    }).catch(() => {})
  },
  // 取消日历中的日程 根据事件id
  deleteCalendarEvent(calendarId, eventId) {
    if (!calendarId || !eventId) {
      console.error('calendarId或eventId不能为空')
      return
    }
    this.commonMethod('calendarChannelMethod', {
      methodType: 'deleteCalendarEvent',
      params: JSON.stringify({
        calendarId,
        eventId
      })
    }).catch(() => {})
  },
  // 取消日历中的日程 根据课开始结束时间
  deleteGymCourseCalendarEvent(startTime, endTime) {
    if (!startTime || !endTime) {
      console.error('startTime或endTime不能为空')
      return
    }
    this.commonMethod('calendarChannelMethod', {
      methodType: 'deleteGymCourseCalendarEvent',
      params: JSON.stringify({
        startTime,
        endTime
      })
    }).catch(() => {})
  },
  //获取app 手机状态栏高度+顶部导航栏的高度
  async getAppTopBarHeight() {
    if (!this.isApp()) {
      return 0
    }
    let res = await this.getAppBarHeight().catch(() => {})
    if (res) {
      return res.toolsBarHeight + res.statusBarHeight
    } else {
      return 0
    }
  }
}
export default app
